import * as React from 'react';
import { AdminState } from './admin.types';
import { AuthState } from '../auth/auth.types';
import { isAuthTokenExpired } from '../commons/AuthTokenValidator';
import CommonFeatures from '../commons/CommonFeatures';
import { BusinessState } from 'src/business/business.types';

type Props = {
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly businessState: BusinessState
  readonly toSignup: () => void
};

type States = {
  
};

class AdminDashboardComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);

    this.state = {

    };
  }

  componentDidMount() {
    return;
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props !== nextProps && !isAuthTokenExpired() && nextProps.authState.statusCode === 200) {
      return;
    }
  }

  render() {
    const { authState } = this.props;

    return(
      <CommonFeatures
        authState={this.props.authState}
        businessState={this.props.businessState}
      >
        <div className="row no-gutters mt-2 mb-2">
          <div className="col-7"><h1>Welcome {authState.account ? authState.account.firstName : ''} !</h1></div>
        </div>
      </CommonFeatures>
    );
  }
}

export default AdminDashboardComponent;



// WEBPACK FOOTER //
// ./src/admin/admin.dashboard.component.tsx